"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = void 0;
const get_path_segments_1 = require("./get-path-segments");
const is_object_1 = require("./is-object");
const is_string_1 = require("./is-string");
exports.set = (object, path, value) => {
    if (!is_object_1.isObject(object) || !is_string_1.isString(path)) {
        return false;
    }
    const pathSegments = get_path_segments_1.getPathSegments(path);
    for (let i = 0; i < pathSegments.length; i++) {
        const pathSegment = pathSegments[i];
        if (!is_object_1.isObject(object[pathSegment])) {
            object[pathSegment] = {};
        }
        if (i === pathSegments.length - 1) {
            object[pathSegment] = value;
        }
        object = object[pathSegment];
    }
    return true;
};
//# sourceMappingURL=set.js.map